/* ============ Birk Theme — Global JS ============ */
(function () {
  "use strict";

  /* ---------- Editor tematu: blocca la navigazione dell'anteprima (evita la 404) ----------
     Nell'editor i link a prodotti/pagine/policy che non esistono ancora sullo store
     portano l'anteprima sul template 404. Qui li rendiamo inerti SOLO in design mode:
     sullo store pubblico funzionano normalmente. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener(
      "click",
      function (e) {
        var el = e.target;
        var link = el && el.closest ? el.closest("a[href]") : null;
        if (!link) return;
        var href = link.getAttribute("href") || "";
        if (!href || href.charAt(0) === "#") return;
        if (href.indexOf("javascript:") === 0 || href.indexOf("mailto:") === 0 || href.indexOf("tel:") === 0) return;
        if (link.target === "_blank") return;
        if (link.hasAttribute("data-allow-nav")) return;
        e.preventDefault();
      },
      true
    );
  }

  var moneyFormat = function (cents) {
    var format = window.themeMoneyFormat || "{{amount_with_comma_separator}} zł";
    var noDecimals = format.indexOf("no_decimals") > -1;
    var comma = format.indexOf("comma_separator") > -1;
    var fixed = (cents / 100).toFixed(noDecimals ? 0 : 2);
    var parts = fixed.split(".");
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? "." : ",");
    var amount = parts[1] ? intPart + (comma ? "," : ".") + parts[1] : intPart;
    return format.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
  };

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById("CartDrawer");
  var overlay = document.getElementById("CartDrawerOverlay");
  var itemsEl = document.getElementById("CartDrawerItems");
  var totalEl = document.getElementById("CartDrawerTotal");
  var footerEl = document.getElementById("CartDrawerFooter");
  var countEls = document.querySelectorAll("[data-cart-count]");

  function openDrawer() {
    document.body.classList.add("cart-open");
  }
  function closeDrawer() {
    document.body.classList.remove("cart-open");
  }

  function updateCount(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute("hidden");
      else el.setAttribute("hidden", "");
    });
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    updateCount(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Twój koszyk jest pusty</p>';
      if (footerEl) footerEl.style.display = "none";
      return;
    }
    if (footerEl) footerEl.style.display = "";

    itemsEl.innerHTML = cart.items
      .map(function (item, index) {
        var img = item.image
          ? '<img src="' + item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + "width=128" + '" alt="">'
          : '<div style="width:64px;height:64px;border-radius:8px;background:var(--color-card)"></div>';
        return (
          '<div class="cart-line" data-line="' + (index + 1) + '">' +
          img +
          '<div class="cart-line__info">' +
          '<p class="cart-line__title">' + item.product_title + "</p>" +
          (item.variant_title ? '<p class="cart-line__variant">' + item.variant_title + "</p>" : "") +
          '<p class="cart-line__price">' + moneyFormat(item.final_line_price) + "</p>" +
          '<div class="cart-line__qty">' +
          '<button type="button" data-qty-change="-1" aria-label="Zmniejsz ilość">\u2212</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-qty-change="1" aria-label="Zwiększ ilość">+</button>' +
          "</div>" +
          '<button type="button" class="cart-line__remove" data-remove>Usuń</button>' +
          "</div></div>"
        );
      })
      .join("");

    if (totalEl) totalEl.textContent = moneyFormat(cart.total_price);
  }


  /* ---------- Rotte + parsing risposte robusto ---------- */
  var R = window.themeRoutes || {};
  var ROUTE_CART = (R.cart || "/cart") + ".js";
  var ROUTE_ADD = (R.cartAdd || "/cart/add") + ".js";
  var ROUTE_CHANGE = (R.cartChange || "/cart/change") + ".js";

  function parseJsonResponse(r) {
    return r.text().then(function (txt) {
      var data = null;
      try { data = JSON.parse(txt); } catch (e) {}
      if (data === null) {
        // Shopify ha risposto con una pagina HTML (password, redirect dominio, pagina di errore):
        // estraiamo il messaggio leggibile invece di mostrare l'errore di parsing
        var m = txt.match(/<p[^>]*>([^<]{10,300})<\/p>/i);
        var msg = m ? m[1].replace(/\s+/g, " ").trim() : "";
        if (/password/i.test(txt)) msg = "Sklep jest chroniony hasłem – dodawanie do koszyka nie działa w podglądzie.";
        throw { status: r.status, description: msg || ("Nieoczekiwana odpowiedź serwera (" + r.status + ")"), html: true };
      }
      if (!r.ok) throw data;
      return data;
    });
  }

  function fetchCart() {
    return fetch(ROUTE_CART, { headers: { Accept: "application/json" } })
      .then(parseJsonResponse)
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function changeLine(line, quantity) {
    return fetch(ROUTE_CHANGE, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(parseJsonResponse)
      .then(renderCart)
      .catch(function () { window.location.href = R.cart || "/cart"; });
  }

  document.addEventListener("click", function (e) {
    var target = e.target;

    if (target.closest("[data-cart-toggle]")) {
      e.preventDefault();
      fetchCart().then(openDrawer);
      return;
    }
    if (target.closest("[data-cart-close]") || target === overlay) {
      closeDrawer();
      return;
    }

    var qtyBtn = target.closest("[data-qty-change]");
    if (qtyBtn) {
      var lineEl = qtyBtn.closest("[data-line]");
      var line = parseInt(lineEl.dataset.line, 10);
      var current = parseInt(lineEl.querySelector(".cart-line__qty span").textContent, 10);
      changeLine(line, Math.max(0, current + parseInt(qtyBtn.dataset.qtyChange, 10)));
      return;
    }

    var removeBtn = target.closest("[data-remove]");
    if (removeBtn) {
      var lineEl2 = removeBtn.closest("[data-line]");
      changeLine(parseInt(lineEl2.dataset.line, 10), 0);
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll("form[data-ajax-cart]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;

      var errEl = form.querySelector("[data-cart-error]");
      if (errEl) { errEl.hidden = true; errEl.textContent = ""; }

      fetch(ROUTE_ADD, {
        method: "POST",
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: new FormData(form),
      })
        .then(parseJsonResponse)
        .then(function () {
          openDrawer();
          return fetchCart();
        })
        .catch(function (data) {
          // Shopify rifiuta l'aggiunta (variante esaurita, quantità non disponibile...):
          // mostriamo il messaggio nella pagina invece di finire sulla pagina di errore
          var msg = (data && (data.description || data.message)) || "";
          if (errEl) {
            errEl.textContent = msg || "Nie udało się dodać produktu do koszyka.";
            errEl.hidden = false;
          } else if (msg) {
            alert(msg);
          }
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  });

  /* ---------- Sticky mobile CTA triggers main form ---------- */
  document.querySelectorAll("[data-trigger-add]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      // la barra sticky appartiene alla scheda prodotto principale:
      // usa quel form, non il primo form della pagina (es. hero-product)
      var main = document.querySelector("[data-main-product]");
      var form =
        (main && main.querySelector("form[data-ajax-cart]")) ||
        document.querySelector("form[data-ajax-cart]");
      if (form) form.dispatchEvent(new Event("submit", { cancelable: true }));
    });
  });

  /* ---------- Sticky CTA: visibile solo dopo che il CTA principale esce dallo schermo ---------- */
  (function () {
    var sticky = document.querySelector(".sticky-cta");
    if (!sticky) return;
    var mainBtn =
      document.querySelector('form[data-ajax-cart] button[type="submit"]') ||
      document.querySelector('form[data-ajax-cart] .shopify-payment-button') ||
      document.querySelector('form[data-ajax-cart]');
    if (!mainBtn || !("IntersectionObserver" in window)) {
      sticky.classList.add("is-visible"); // fallback: comportamento precedente
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        // mostra la barra solo quando il bottone principale è USCITO sopra il viewport
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle("is-visible", passed);
      },
      { threshold: 0 }
    );
    observer.observe(mainBtn);
  })();

  /* ---------- Sticky checkout form: tiene allineata la variante scelta ---------- */
  (function () {
    var stickyId = document.querySelector("[data-sticky-variant-id]");
    if (!stickyId) return;
    function sync() {
      var scope = document.querySelector("[data-main-product]") || document;
      var main = scope.querySelector("[data-variant-id]");
      if (main && main.value) stickyId.value = main.value;
    }
    document.addEventListener("change", function () { setTimeout(sync, 0); });
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-option-group]")) setTimeout(sync, 0);
    });
    sync();
  })();

  /* ---------- Product gallery ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var mainImg = gallery.querySelector("[data-gallery-main] img");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.src;
        mainImg.srcset = "";
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
          t.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });
  });

  /* ---------- Menu drawer + quantity selector ---------- */
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-menu-toggle]")) {
      document.body.classList.add("menu-open");
      return;
    }
    if (e.target.closest("[data-menu-close]")) {
      document.body.classList.remove("menu-open");
      return;
    }
    var qtyBtn = e.target.closest("[data-qty-btn]");
    if (qtyBtn) {
      var input = qtyBtn.parentElement.querySelector("input[name='quantity']");
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + parseInt(qtyBtn.dataset.qtyBtn, 10));
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") document.body.classList.remove("menu-open");
  });

  /* ---------- Variant picker: swatch colore + tendina ---------- */
  document.querySelectorAll("[data-variant-picker]").forEach(function (picker) {
    var jsonEl = picker.querySelector("[data-variant-json]");
    var hidden = picker.querySelector("[data-variant-id]");
    if (!jsonEl || !hidden) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = picker.closest("form");
    if (!form && hidden.getAttribute("form")) {
      form = document.getElementById(hidden.getAttribute("form"));
    }
    var submitBtn = form ? form.querySelector('button[type="submit"]') : null;
    var addText = submitBtn ? submitBtn.textContent.trim() : "";
    var soldOutText = picker.dataset.soldOutText || "Wyprzedane";

    function currentOptions() {
      var opts = [];
      picker.querySelectorAll("[data-option-group]").forEach(function (group) {
        var idx = parseInt(group.dataset.optionIndex, 10);
        if (group.tagName === "SELECT") {
          opts[idx] = group.value;
        } else {
          var checked = group.querySelector("input:checked");
          opts[idx] = checked ? checked.value : null;
        }
      });
      return opts;
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < variants[i].options.length; j++) {
          if (opts[j] != null && variants[i].options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function refreshAvailability(opts) {
      picker.querySelectorAll("[data-option-group]").forEach(function (group) {
        var idx = parseInt(group.dataset.optionIndex, 10);
        var entries = group.tagName === "SELECT"
          ? Array.prototype.slice.call(group.options)
          : Array.prototype.slice.call(group.querySelectorAll("input[type=radio]"));
        entries.forEach(function (entry) {
          var test = opts.slice();
          test[idx] = entry.value;
          var m = matchVariant(test);
          var available = !!(m && m.available);
          if (group.tagName === "SELECT") {
            if (!entry.dataset.baseText) entry.dataset.baseText = entry.textContent.trim();
            entry.disabled = !m;
            entry.textContent = available ? entry.dataset.baseText : entry.dataset.baseText + " \u2014 " + soldOutText;
          } else {
            entry.disabled = !available;
          }
        });
      });
    }

    function update() {
      var opts = currentOptions();
      var variant = matchVariant(opts);

      picker.querySelectorAll("[data-selected-option]").forEach(function (el) {
        var idx = parseInt(el.dataset.selectedOption, 10);
        if (opts[idx] != null) el.textContent = opts[idx];
      });
      refreshAvailability(opts);

      if (!variant) {
        if (submitBtn) submitBtn.disabled = true;
        return;
      }
      hidden.value = variant.id;
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? addText : soldOutText;
      }
      // la barra sticky segue la variante scelta nella scheda prodotto principale
      var isMainPicker = !!picker.closest("[data-main-product]");
      if (isMainPicker) document.querySelectorAll("[data-trigger-add]").forEach(function (sb) {
        sb.disabled = !variant.available;
        var a = sb.dataset.addText || addText;
        var so = sb.dataset.soldOutText || soldOutText;
        sb.textContent = variant.available ? a : so;
      });
      var stickyInput = isMainPicker ? document.querySelector("[data-sticky-variant-id]") : null;
      if (stickyInput) stickyInput.value = variant.id;
      if (variant.image) {
        var img = null;
        var hero = picker.closest(".hero");
        if (hero) img = hero.querySelector(".hero__image img");
        else img = document.querySelector("[data-gallery-main] img");
        if (img && img.getAttribute("src") !== variant.image) {
          img.src = variant.image;
          img.removeAttribute("srcset");
        }
      }
    }

    picker.addEventListener("change", update);
    picker.addEventListener("input", update);
    picker.addEventListener("click", function (e) {
      if (e.target.closest("label")) setTimeout(update, 0);
    });
    update();
  });

  /* ---------- Init cart count on load ---------- */
  fetch(ROUTE_CART, { headers: { Accept: "application/json" } })
    .then(parseJsonResponse)
    .then(function (cart) { updateCount(cart.item_count); })
    .catch(function () {});
})();
